import api from './api';

export const invoiceService = {
  getAll: async (params = {}) => {
    const response = await api.get('/invoices', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/invoices/${id}`);
    return response.data;
  },

  generate: async (siteVisitId, data = {}) => {
    const response = await api.post(`/invoices/generate/${siteVisitId}`, data);
    return response.data;
  },

  getRevenueReports: async (params = {}) => {
    const response = await api.get('/invoices/reports/revenue', { params });
    return response.data;
  },

  updatePayment: async (id, data) => {
    const response = await api.put(`/invoices/${id}/payment`, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/invoices/${id}`, data);
    return response.data;
  },

  download: async (id) => {
    const response = await api.get(`/invoices/${id}/download`, {
      responseType: 'blob'
    });
    return response.data;
  },

  getStats: async () => {
    const response = await api.get('/invoices/stats/summary');
    return response.data;
  },
};

export default invoiceService;
